import { Box, Button, Slider, Typography } from "@mui/material";
import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { btnStyleContrast } from "../../helper/style";

const ImageCropper = ({ imageSrc, onCropDone, aspectRatio = 1, originalFile = null, resetImage = () => {} }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // called when user stops dragging/zooming
  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // helper to create an <img> object
  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
    });

  // actually crop using <canvas>
  const getCroppedImage = async () => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      croppedAreaPixels.width,
      croppedAreaPixels.height
    );

    // return base64
    const base64Image = canvas.toDataURL("image/png");
    onCropDone(base64Image);
  };

  return (
    <Box>
      <Box position="relative" width="100% " height="400px">
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          rotation={rotation}
          aspect={aspectRatio}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      </Box>
      <Box marginTop={5}> 
        <Typography>
          Zoom
        </Typography>
        <Slider 
          defaultValue={1}
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(_, newValue) => setZoom(newValue)}
        />
      </Box>
      <Box marginTop={1}> 
        <Typography>
          Rotation
        </Typography>
        <Slider 
          defaultValue={0}
          min={0}
          max={360}
          step={1}
          value={rotation}
          onChange={(_, newValue) => setRotation(newValue)}
        />
      </Box>
      <Box marginTop={2} display="flex" justifyContent="end">
        {
          originalFile && (
            <Button
              onClick={resetImage}
              sx={{ ...btnStyleContrast, width: "150px", borderRadius: "100px", marginRight: "10px" }}  
            >
              Reset Image
            </Button>
          )
        }
        <Button
          onClick={getCroppedImage}
          sx={{ ...btnStyleContrast, width: "150px", borderRadius: "100px" }}  
        >
          Crop
        </Button>
      </Box>
    </Box>
  );
};

export default ImageCropper;
